import React from "react"
import Contest from "./Contest"
import CircularProgress from "@material-ui/core/CircularProgress";
import randomColor from "randomcolor";
class ContestPlatform extends React.Component
{
    constructor(props)
    {
        super(props)
        this.state={
            isLoading:true,
            contestData:[],
            color:randomColor({luminosity:"dark"}),
        }
    }

    componentDidMount()
    {
        const function_path= "/.netlify/functions/";
        const url = function_path + this.props.function_name;
        fetch(url)
        .then(response => response.json())
        .then( contests => this.setState({
            isLoading:false,
            contestData:contests
        }))
    }

    render()
    {
        const style={
            background:"white",
            display:"flex",
            flexDirection:'column',
     
            borderRadius:"10px",
            padding:"30px",
            flexBasis:"300px",
            margin:"10px 10px"
        }
        console.log(randomColor())
        const ContestComponents = this.state.contestData.map(x => <Contest {...x}/>)
        return(
            <div style={style}>
                <div style={{borderRadius:"10px",padding:"40px 40px 10px 10px",backgroundColor:this.state.color}}>
                    <h1 style={{fontFamily:"raleway",color:"white",fontSize:"40px",margin:0}}>
                        {this.props.providerName}   
                    </h1>    
                </div>
                <div style={{margin:"20px 0px"}}>
                    {this.state.isLoading ? <CircularProgress /> : ContestComponents}
                </div>
            </div>           
        )
    }
}
export default ContestPlatform;